import React, { useRef, useState } from "react";
import HeroBanner from "../../../reusable-components/hero_banners/HeroBanner";
import H1 from "../../../reusable-components/headings/H1";
import { useForm } from "react-hook-form";
import Input from "../../../reusable-components/inputs/InputTextBox/Input";
import SubmitButton from "../../../reusable-components/buttons/SubmitButton";
import { full_width_button } from "../../../theme/lightTheme";
import { contactnoPattern } from "../../../utilities/generalFunctions/regexPatterns";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FiInfo, FiShield } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function ApplicantLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: "",
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    console.log("data", data);

    let applicantDetails = {
      phoneNo: data?.phone_number,
      serialNo: uniqueSerialNumber,
    };
    try {
      // navigate(`/noc-applicant-veriffy-otp`);
      navigate("/noc-applicant-veriffy-otp", {
        state: { applicantDetails },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const { uniqueSerialNumber } = location.state || {};

  console.log("uniqueSerialNumber", uniqueSerialNumber);

  return (
    <section>
      <HeroBanner>
        <div className="absolute left-10 md:left-14 lg:left-1/5 right-10 md:right-14 lg:right-10 top-1/2">
          <div className="text-center">
            <H1>Verify Contact Number</H1>
          </div>
        </div>
      </HeroBanner>

      <section className="my-12 min-h-screen">
        <div className="mx-auto w-11/12 md:w-3/4 lg:w-1/2 xl:w-2/5">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-lg">
            {/* Header */}
            <div className="bg-gradient-to-r from-primary to-primary/90 px-8 py-8 text-white">
              <div className="flex flex-col items-center">
                {/* <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-white/15">
                  <FiShield className="h-8 w-8" />
                </div> */}

                <p className="text-sm uppercase tracking-[0.2em] text-white/70">
                  NOC Serial Number
                </p>

                <div className="mt-2 rounded-xl border border-white/20 bg-white/10 px-6 py-3 backdrop-blur-sm">
                  <span className="font-mono text-2xl font-bold tracking-wider">
                    {uniqueSerialNumber}
                  </span>
                </div>

                <p className="mt-5 max-w-lg text-center text-sm leading-relaxed text-white/85">
                  Enter the registered mobile number to continue your payment or
                  track the status of your application.
                </p>
              </div>
            </div>

            {/* Body */}
            <div className="p-8">
              <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50 p-4">
                <div className="flex items-start gap-3">
                  <FiInfo className="mt-1 h-5 w-5 text-blue-600" />

                  <div className="text-sm text-blue-900">
                    <p className="font-semibold">
                      Why do we need your mobile number?
                    </p>

                    <ul className="mt-2 list-disc pl-5 space-y-1">
                      <li>To prevent spam and misuse.</li>
                      <li>To allow payment tracking.</li>
                      <li>
                        The mobile number does <strong>not</strong> have to
                        belong to the applicant.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <p
                  ref={errRef}
                  className={
                    errMsg
                      ? "mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-red-700"
                      : "hidden"
                  }
                  aria-live="assertive"
                >
                  {errMsg}
                </p>

                <Input
                  defaultName="phone_number"
                  register={register}
                  name="Mobile Number"
                  required={false}
                  pattern={contactnoPattern}
                  errors={errors}
                  placeholder="Enter your mobile number"
                  setError={setError}
                  clearError={clearErrors}
                  autoComplete="tel"
                  type="tel"
                  classes="w-full rounded-lg border-gray-300 px-4 py-3"
                  onChangeInput={null}
                  defaultValue={null}
                  setValue={setValue}
                />

                {uniqueSerialNumber ? (
                  <SubmitButton
                    isSubmitting={isSubmitting}
                    label="Continue"
                    className="mt-6 w-full rounded-lg bg-primary py-3 text-base text-white font-semibold"
                  />
                ) : (
                  <Link
                    to="/noc-application"
                    className="mt-5 inline-flex w-full items-center justify-center rounded-lg bg-primary px-4 py-3 text-sm font-medium text-white transition hover:bg-primary/90"
                  >
                    Go to Check Application Status
                  </Link>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}
